import { PaymentConfigDto } from './dtos';

interface PaddleClient {
    Environment: { set: (environment: 'sandbox') => void };
    Initialize: (options: { token: string; eventCallback: (event: { name: string }) => void }) => void;
    Checkout: { open: (options: { transactionId: string; settings: { displayMode: 'overlay'; showAddDiscounts: boolean; allowLogout: boolean } }) => void; close: () => void };
}
declare global { interface Window { Paddle?: PaddleClient } }

let loading: Promise<PaddleClient> | null = null;
let initializedToken: string | null = null;
let callback: ((name: string) => void) | null = null;

function loadPaddle(): Promise<PaddleClient> {
    if (window.Paddle) return Promise.resolve(window.Paddle);
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdn.paddle.com/paddle/v2/paddle.js';
        script.async = true;
        const timer = window.setTimeout(() => fail(), 15000);
        const fail = () => {
            window.clearTimeout(timer);
            script.remove();
            loading = null;
            reject(new Error('Could not load payment checkout. Please try again.'));
        };
        script.onerror = fail;
        script.onload = () => {
            window.clearTimeout(timer);
            if (window.Paddle) resolve(window.Paddle);
            else fail();
        };
        document.head.appendChild(script);
    });
    return loading;
}

export async function openCourseCheckout(config: PaymentConfigDto, transactionId: string, onEvent: (name: string) => void): Promise<void> {
    const paddle = await loadPaddle();
    callback = onEvent;
    if (initializedToken !== config.client_token) {
        if (initializedToken !== null) throw new Error('Payment settings changed. Please reload this page.');
        if (config.environment === 'sandbox') paddle.Environment.set('sandbox');
        paddle.Initialize({ token: config.client_token, eventCallback: event => callback?.(event.name) });
        initializedToken = config.client_token;
    }
    paddle.Checkout.open({ transactionId, settings: { displayMode: 'overlay', showAddDiscounts: false, allowLogout: false } });
}

export function releaseCourseCheckout(): void { callback = null; }
